module.exports = __webpack_public_path__ + "static/media/companies-icon-3.3418e00e.svg";